import { FC } from "react";
import { FaRulerHorizontal } from "react-icons/fa";

import { cn } from "@/lib/cn";

import { useGetUnit } from "../hooks/api/use-get-unit";

interface UnitViewProps {
  unit?:
    | {
        id: string;
      }
    | null
    | undefined;
  hideLogo?: boolean;
  hideText?: boolean;
  placeholder?: string;
  showPlaceholder?: boolean;
  className?: string;
}

export const UnitView: FC<UnitViewProps> = ({
  hideLogo = false,
  hideText = false,
  placeholder = "Einheit",
  showPlaceholder = true,
  className,
  ...props
}) => {
  const { unit } = useGetUnit({
    id: props.unit?.id,
  });

  return (
    <div className={cn("flex items-center gap-2", className)}>
      {!hideLogo && <FaRulerHorizontal className="h-4 w-4 text-foreground/60" />}
      {!hideText && (
        <>
          {unit ? (
            <span className="whitespace-nowrap">
              {unit.title} {unit.symbol && `(${unit.symbol})`}
            </span>
          ) : (
            <>{showPlaceholder && <span className="whitespace-nowrap">{placeholder}</span>}</>
          )}
        </>
      )}
    </div>
  );
};
